(function () {
  const container = document.getElementById('ProductGridContainer');
  const wrapper = document.querySelector('.collection-loadmore');
  const btn = document.getElementById('LoadMoreBtn');
  const spinner = document.getElementById('LoadMoreSpinner');

  if (!container || !wrapper || !btn) return;

  async function fetchAndAppend(nextUrl) {
    spinner.hidden = false;
    btn.disabled = true;

    try {
      const res = await fetch(nextUrl, { credentials: 'same-origin' });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // Find next page’s grid items
      const nextContainer = doc.querySelector('#ProductGridContainer');
      const nextItems = nextContainer ? nextContainer.querySelectorAll('.grid__item') : [];

      // Append new items to current grid
      const currentGrid = container.querySelector('.grid');
      nextItems.forEach((it) => currentGrid.appendChild(it));

      // Update next URL
      const nextWrapper = doc.querySelector('.collection-loadmore');
      const nextHref = nextWrapper ? nextWrapper.getAttribute('data-next-url') : '';

      if (nextHref) {
        wrapper.setAttribute('data-next-url', nextHref);
        btn.disabled = false;
      } else {
        btn.textContent = 'All products loaded';
        btn.disabled = true;
      }
    } catch (e) {
      btn.disabled = false;
    } finally {
      spinner.hidden = true;
    }
  }

  btn.addEventListener('click', () => {
    const nextUrl = wrapper.getAttribute('data-next-url');
    if (nextUrl) fetchAndAppend(nextUrl);
  });
})();
